/* eslint-disable react/prop-types */
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import moment from "moment/moment";
import * as Sentry from "@sentry/react";
import Table from "../../../components/common/new/Table/Table";
import tableStyle from "../../../theme/styles/table";
import EyeIcon from "../../../assets/svg/Eye";
import { AlertStatus, PERMISSIONS } from "../../../contants";
import style from "./FriendTable.styles";
import { FRIEND_SEAECH_TABLE_COL } from "../../../contants/table/friendSearch";
import FriendToMember from "../../../assets/svg/FriendToMember";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Friends from "../../../services/api/friend";

const FRIEND_TYPE = "FRIEND";
const NEW_FRIEND_TYPE = "NEW_FRIEND"; // ✅ Naya constant add kiya

const getRows = ({
  searchData,
  onSelectFriendForTransfer,
  onFriendStatusToggle,
  hasPermission,
  onSelectFriend,
}) =>
  searchData.map((friendInfo) => {
    const toast = useContext(ToastAlertContext);

    const isAnyFriend =
      friendInfo.type === FRIEND_TYPE || friendInfo.type === NEW_FRIEND_TYPE;

    const transferEligibility = async () => {
      try {
        const response = await Friends.friendTransferEligibility({
          friendId: friendInfo.friendId,
        });
        if (response.message === "eligible") {
          onSelectFriendForTransfer(friendInfo, response.message);
        }
      } catch (error) {
        toast.show(error.message, AlertStatus.ERROR);
        Sentry.captureException(error);
      }
    };

    const handleTransferClick = () => {
      transferEligibility();
    };

    const profileUrl = `/friend/details/${friendInfo.friendId}`;

    return (
      <TableRow key={friendInfo.friendId}>
        {/* Friend Id */}
        <TableCell>{friendInfo.friendId || "-"}</TableCell>

        {/* Name + Address */}
        <TableCell>
          <span style={style.typeLabel}>
            {friendInfo.type === FRIEND_TYPE ? "F" : "NF"}
          </span>{" "}
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "rgba(118, 24, 32, 0.87)",
              fontWeight: 600,
              cursor: "pointer",
              textDecoration: "none",
            }}
          >
            {friendInfo.fullName}
          </a>
          <br />
          <LocationOnIcon style={tableStyle.locationIcon} />
          {friendInfo.addressLine1} <br /> {friendInfo.cityName},{" "}
          {friendInfo.stateName} - {friendInfo.pincode}
        </TableCell>

        {/* Contact */}
        <TableCell>
          <PhoneIcon style={tableStyle.icon} /> {friendInfo.mobileNumber || "-"}
          <br />
          <EmailIcon style={tableStyle.icon} /> {friendInfo.emailId || "-"}
        </TableCell>

        {/* Division */}
        <TableCell>{friendInfo.divisionName || "-"}</TableCell>

        {/* Area / Zone / Region / Chapter / District */}
        <TableCell>
          {[
            friendInfo?.areaName || "-",
            friendInfo?.clusterName || "-",
            friendInfo?.zoneName || "-",
            friendInfo?.regionName || "-",
            friendInfo?.chapterName || "-",
            friendInfo?.districtName || "-",
          ].map((val, idx, arr) => (
            <React.Fragment key={`${friendInfo.friendId}-${val}`}>
              {val}
              {idx < arr.length - 1 && (
                <>
                  <span>/ </span>
                  {idx === 2 && <br />}
                </>
              )}
            </React.Fragment>
          ))}
        </TableCell>

        {/* Date */}
        <TableCell style={{ textAlign: "center" }}>
          {friendInfo.createdAt
            ? moment(friendInfo.createdAt).format("DD/MM/YYYY")
            : "-"}
        </TableCell>

        {/* Actions */}
        <TableCell style={{ maxWidth: "12rem" }}>
          <div style={style.actionButtons}>
            <a
              href={profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "inline-flex" }}
            >
              <EyeIcon style={style.actionIcon} />
            </a>

            {/* ✅ friendInfo.type === FRIEND_TYPE → isAnyFriend */}
            {isAnyFriend &&
              hasPermission(PERMISSIONS.INITIATE_TRANSFER_FRIEND) && (
                <Tooltip title="Transfer">
                  <TransferWithinAStationIcon
                    style={style.actionIcon}
                    onClick={handleTransferClick}
                  />
                </Tooltip>
              )}

            {/* ✅ friendInfo.type === FRIEND_TYPE → isAnyFriend */}
            {isAnyFriend &&
              hasPermission(PERMISSIONS.CONVERT_TO_FRIEND_MEMBER) && (
                <FriendToMember
                  style={{ ...style.actionIcon }}
                  onClick={() => onSelectFriend(friendInfo)}
                />
              )}

            {/* ✅ friendInfo.type === FRIEND_TYPE → isAnyFriend */}
            {isAnyFriend &&
              hasPermission(PERMISSIONS.DEACTIVATE_FRIEND) &&
              friendInfo.status === "ACTIVE" && (
                <Tooltip title="Deactivate">
                  <DoDisturbIcon
                    style={{
                      ...style.actionIcon,
                      color: "#7DEB6D",
                      fontSize: "1.5rem",
                    }}
                    onClick={() => onFriendStatusToggle(friendInfo)}
                  />
                </Tooltip>
              )}
          </div>
        </TableCell>
      </TableRow>
    );
  });

function FriendTable({
  searchData,
  onSelectFriendForTransfer,
  onFriendStatusToggle,
  hasPermission,
  onSelectFriend,
}) {
  return (
    <div style={style.container}>
      <Table
        scrollable
        columns={FRIEND_SEAECH_TABLE_COL}
        rows={getRows({
          searchData,
          onSelectFriendForTransfer,
          onFriendStatusToggle,
          hasPermission,
          onSelectFriend,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...style.tableHeadCells,
          textAlign: "left",
        }}
      />
    </div>
  );
}

export default FriendTable;
